import {
  ChangeDetectionStrategy,
  Component,
  DestroyRef,
  OnInit,
  inject,
  input,
  output,
  signal,
} from '@angular/core';
import { FormsModule } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';

import { MatButton } from '@angular/material/button';

import { FsDateModule } from '@firestitch/date';
import { FsFormModule } from '@firestitch/form';

import { Observable, of } from 'rxjs';
import { tap } from 'rxjs/operators';

import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { TermsTypes } from '@common/consts';
import { SettingData } from '@common/data';
import { indexByValue } from '@common/helpers';
import { TermsTypeKey } from '@common/interfaces';

import { LogoComponent } from '@libs/logo/components';
import { StackedButtonsComponent } from '@libs/stacked-buttons/components';
import { TermsCheckboxComponent } from '@libs/terms-checkbox';

import { SignoutService } from '@app/core';


@Component({
    selector: 'app-terms-display',
    templateUrl: './terms-display.component.html',
    styleUrls: ['./terms-display.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true,
    imports: [
    FormsModule,
    FsFormModule,
    LogoComponent,
    TermsCheckboxComponent,
    StackedButtonsComponent,
    MatButton,
    FsDateModule
],
})
export class TermsDisplayComponent implements OnInit {
  public type = input.required<TermsTypeKey>();
  public header = input<string>();
  public message = input<string>();
  public skippable = input(false);

  public submitted = output();
  public skipped = output();

  public effectiveDate = signal<Date | null>(null);

  public submit = (): Observable<boolean> => {
    this.submitted.emit();

    return of(true);
  };

  private _signoutService = inject(SignoutService);
  private _settingData = inject(SettingData);
  private _router = inject(Router);
  private _route = inject(ActivatedRoute);
  private _destroyRef = inject(DestroyRef);

  public ngOnInit(): void {
    this._settingData.get(indexByValue(TermsTypes)[this.type()].effectiveDateSetting)
      .pipe(
        tap((effectiveDate: Date): void => this.effectiveDate.set(effectiveDate)),
        takeUntilDestroyed(this._destroyRef),
      )
      .subscribe();
  }

  public cancel(): void {
    this._signoutService.destroy()
      .subscribe(() => {
        this._router.navigate(['../../'], { relativeTo: this._route });
      });
  }

  public skipForNow(): void {
    this.skipped.emit();
  }

}
